// import 'react-app-polyfill/ie9';
import "react-app-polyfill/ie11";
//import 'react-app-polyfill/stable';

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import DplayActivate from "./DplayActivate";
import ViaplayActivate from "./ViaplayActivate";
import ParamountActivate from "./ParamountActivate";
import CMoreActivate from "./CMoreActivate";
import SkyShowtimeActivate from "./SkyShowtimeActivate"
import SkyShowtimetest from "./SkyShowtimeTest";
import ActivateSelection from "./ActivateSelection";
import ActivateAtvSappaPlay from "./SappaPlayActivateTv";
import ViaplayActivateBitcom from "./ViaplayActivateBitcom";
import TV4PlayActivate from "./TV4PlayActivate";
import ReadlyActivate from "./ReadlyActivate";
import PodmeActivate from "./PodmeActivate";
import DisneyActivate from "./DisneyplayActivate";
import Rejected from "./Rejected";
import Cookies from "js-cookie";

ReactDOM.render(
  <React.StrictMode>
    <Router path="/">
      <Switch>

        <Route path="/disney">
          <DisneyActivate />
        </Route>
        <Route path="/dplay-activate">
          <DplayActivate />
        </Route>
        <Route path="/discovery">
          <DplayActivate />
        </Route>
        {/* <Route path="/paramount">
          <ParamountActivate />
        </Route> */}
        <Route path="/viaplay">
          <ViaplayActivate />
        </Route>
        <Route path="/cmore">
          <TV4PlayActivate />
        </Route>
        <Route path="/tv4play">
          <TV4PlayActivate />
        </Route>
        <Route path="/skyshowtime">
          <SkyShowtimeActivate />
        </Route>
        <Route path="/skyshowtimetest">
          <SkyShowtimetest />
        </Route>
        <Route path="/rejected">
          <Rejected />
        </Route>
        <Route path="/sappaplay">
          <ActivateAtvSappaPlay />
        </Route>
        <Route path="/bitcom/viaplay">
          <ViaplayActivateBitcom />
        </Route>
        <Route path="/readly">
          <ReadlyActivate />
        </Route>
        <Route path="/podme">
          <PodmeActivate />
        </Route>
        <Route path="/">
          <ActivateSelection />
        </Route>
        
        {/* <Route path='/dplay-activate' component={() => { 
        window.location.href = GetActivationUrl(); 
        return null;
    }}/> */}
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
